import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';

import { SupplierAuthService } from '../services/supplier-auth.service';

export const ccmsApiInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(SupplierAuthService);
  const router = inject(Router);

  return next(withAuth(request, auth, router)).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || isAuthRequest(request.url)) {
        return throwError(() => error);
      }

      return auth.refreshSession().pipe(
        switchMap(() => next(withAuth(request, auth, router))),
        catchError((refreshError: unknown) => {
          auth.handleUnauthorized(router.url);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};

function withAuth(
  request: HttpRequest<unknown>,
  auth: SupplierAuthService,
  router: Router,
) {
  const authToken = auth.accessToken;
  const headers: Record<string, string> = {
    'X-Client-Route': router.url,
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  return request.clone({
    setHeaders: headers,
    withCredentials: true,
  });
}

function isAuthRequest(url: string) {
  const normalized = url.toLowerCase();

  return (
    normalized.includes('/supplier-portal/login') ||
    normalized.includes('/supplier-portal/login-as') ||
    normalized.includes('/supplier-portal/logout') ||
    normalized.includes('/supplier-portal/refresh-session')
  );
}
